import { Directive, OnDestroy } from '@angular/core';
import { ReplaySubject } from 'rxjs';

import { environment } from '../../../environments/environment';
import { isMapsApiLoaded } from '../utils/map-utils';

@Directive({
    standalone: false
})
export abstract class BaseGoogleApiLoader implements OnDestroy {
    api: ReplaySubject<any> = new ReplaySubject(1);

    private baseUrl = 'https://maps.google.com/maps/api/js';
    private libraries = 'places';

    protected apiUrl = `${this.baseUrl}?key=${environment.googleMapsAPIKey}&libraries=${this.libraries}&callback=initThumediMap`;
    protected mapSelector = 'thumedi-map';

    ngOnDestroy(): void {
        this.api.complete();
    }

    isLoaded(): boolean {
        return isMapsApiLoaded();
    }

    abstract load(): void;
}
